module.exports = __webpack_public_path__ + "assets/img/404.a57b6f31.png";